<template>
	<div class="modal-release-note__poster">
		<img
			src="@/assets/img/OrderV2.png"
			alt="Des évolutions dans le module de commande">
	</div>
	<o-section
		class="modal-release-note"
		title="Des évolutions dans le module de commande">
		<div class="flex fd-c g-sm">
			<div>Une mise à jour du module de commande vient d'être publiée sur la plateforme.</div>

			<div>
				Vous aurez désormais la possibilité de préciser votre besoin en ajoutant une ou plusieurs <strong>qualifications secondaires</strong>,
				en sélectionnant un <strong>motif de recours</strong> ainsi qu’en mentionnant son <strong>justificatif</strong>.
			</div>

			<div>
				Vous pourrez également <strong>renseigner les horaires</strong> tout au long de la mission
				en définissant une ou plusieurs plages horaires sur chacun des jours de la semaine.<br>
				Et en cas de besoin, libre à vous d'indiquer des <strong>horaires spécifiques</strong>
				pour des jours ou périodes en particulier durant la mission.
			</div>

			<div>
				Tout aussi pratique, ajoutez l'identité de <strong>l'interlocuteur sur site</strong> pour faciliter la communication avec l'intérimaire.
			</div>

			<div v-if="setup.self.isAgency()">
				Enfin, une fois la commande créée vous aurez la possibilité d’y ajouter des <strong>pièces jointes</strong> dans le
				<strong>Détail de la commande</strong> ou de demander le partage des documents nécessaires à plusieurs intérimaires à la fois
				directement depuis la <strong>Vie de la commande</strong>.
			</div>

			<div>
				Nous sommes à l'écoute de nos utilisateurs et nous espérons que ces évolutions vous feront gagner en efficacité.<br>
				<strong>Merci de faire partie de notre aventure.</strong>
			</div>

			<em class="text--brand">L'équipe ARMADO</em>
		</div>
	</o-section>

	<o-section
		align="right"
		gap="xs">
		<o-button
			color="brand"
			@click="setup.closeReleaseNoteAsync()">
			Fermer
		</o-button>
	</o-section>
</template>

<script setup lang="ts">
import ModalReleaseNoteSetupService from '@/setup/modal/ModalReleaseNoteSetupService';
import { inject } from 'vue';
const _modal = inject<OrionModal>('_modal');
const props = defineProps(ModalReleaseNoteSetupService.props);
const setup = new ModalReleaseNoteSetupService(props, _modal);
</script>

<style scoped lang="less">
@import '@/styles/variables';

.modal-release-note {
  font-size: 1rem;

	&__poster {

		@media @phone {
			margin: -2rem -2rem 2rem;
			max-width: calc(100% + 3.85rem);
		}

		position: relative;
		overflow: hidden;
		max-width: calc(100% + 7.75rem);
		margin: -4rem -4rem 2rem;
	}
}
</style>
